import $ from 'jquery';

export default function () {

}
